<template>
  <section class="Quiz_section QuizMotivation">
    <div class="Quiz_section_wrapper">
      <transition name="bottom" appear>
        <h4 class="Quiz_question" v-if="count >= 2">Plus que 3 questions.<br>On ne lâche rien !</h4>
        <h4 class="Quiz_question" v-else>Et hop !<br>Vous voilà déjà à la moitié du questionnaire !</h4>
      </transition>
      <figure class="Quiz_illustration">
        <div class="Quiz_illustration_image Quiz_illustration_image_bodymovin" ref="bodymovin" :style="{ opacity: lottieLoaded ? 1 : 0 }"></div>
      </figure>
    </div>
  </section>
</template>

<script>
  import page from '@/mixins/page'
  import lottie from 'lottie-web'

  export default {
    name: "QuizMotivation",
    props: [ 'count' ],
    mixins: [ 'page' ],
    data() {
      return {
        anim: null,
        lottieLoaded: false,
        timeout: null
      }
    },
    mounted()
    {
      let path = this.$tools.path()

      let bodyPath = this.count >= 2 ? '/static/datas/illustrations/0-encouragement.json' : '/static/datas/illustrations/1-encouragement.json'
      console.log('motivation path', path + bodyPath)

      this.anim = lottie.loadAnimation({
        container: this.$refs.bodymovin,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: path + bodyPath
      });

      this.anim.addEventListener('DOMLoaded', () => { this.lottieLoaded = true })

      document.body.querySelector('.QuizBackground').classList.remove('QuizBackground_withIllustration')
      document.body.querySelector('.Header').classList.add('Header_withTitle')

      this.timeout = setTimeout( () => {
        this.$emit('nextQuestion')
      }, 3000)
    },
    beforeDestroy()
    {
      clearTimeout(this.timeout)
      document.body.querySelector('.Header').classList.remove('Header_withTitle')
    }
  }
</script>

<style lang="stylus" scoped>

  .QuizMotivation

    .Quiz_section_wrapper

      justify-content center
      align-items center
      margin auto auto

    h4

      margin-top auto
      margin-bottom 30px
      text-align center

    .Quiz_illustration

      margin-top 0px
      margin-bottom auto

  .Quiz_section

    display flex
    flex-direction column
    align-items center

  .Quiz

    &_illustration

      @media $medium
      
        margin-bottom 60px

      @media $small
      
        margin-bottom auto

    &_content

      margin 0px auto auto auto

    .Cta

      margin-top 60px

    &_title

      color $red

.ie

  .QuizMotivation

    height 100vh

    .Quiz_section_wrapper

      height auto
      
</style>